const getSafeUrl = (url?: string): URL | null => {
  if (!url?.trim()) return null;

  try {
    const parsedUrl = new URL(url);
    return parsedUrl.protocol === "http:" || parsedUrl.protocol === "https:"
      ? parsedUrl
      : null;
  } catch {
    return null;
  }
};

const getDownloadName = (url: URL, filename?: string) => {
  if (filename) return filename;

  const encodedName = url.pathname.split("/").pop() || "download";
  try {
    return decodeURIComponent(encodedName) || "download";
  } catch {
    return "download";
  }
};

export const downloadUtil = async (url?: string, filename?: string) => {
  const safeUrl = getSafeUrl(url);
  if (!safeUrl) return;

  try {
    const response = await fetch(safeUrl.href);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const blobUrl = window.URL.createObjectURL(await response.blob());
    const link = document.createElement("a");
    link.href = blobUrl;
    link.setAttribute("download", getDownloadName(safeUrl, filename));
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(blobUrl);
  } catch (error) {
    console.error("Unable to download file:", error);
  }
};

export const directDownloadUtil = (url?: string, filename?: string) => {
  const safeUrl = getSafeUrl(url);
  if (!safeUrl) return;

  const link = document.createElement("a");
  link.href = safeUrl.href;
  link.setAttribute("download", getDownloadName(safeUrl, filename));
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
